<script setup>
import { useToast } from 'primevue/usetoast'
import { watch } from 'vue'

const props = defineProps(['ativarAlerta', 'nomeGrupo', 'detalheAlerta'])

const { add, removeGroup } = useToast()

const onReject = () => removeGroup(props.nomeGrupo)

watch(
  () => props.ativarAlerta,
  () => {
    if (props.ativarAlerta) {
      add({
        severity: 'success',
        summary: 'Sucesso',
        detail: props.detalheAlerta ?? 'CSV sendo gerado',
        group: props.nomeGrupo
      })
    }
  }
)
</script>
<template>
  <Toast position="bottom-center" :group="nomeGrupo">
    <template #message="slotProps">
      <div class="flex flex-column" style="width: 100% !important">
        <div class="text-center">
          <i class="pi pi-check-circle" style="font-size: 3rem"></i>
          <h4>{{ slotProps.message.summary }}</h4>
          <p>{{ slotProps.message.detail }}</p>
        </div>
        <div class="grid p-fluid">
          <div class="col-6">
            <Button class="p-button-success" label="Ver" @click="$router.push({ name: 'relatorios' })" />
          </div>
          <div class="col-6">
            <Button class="p-button-secondary" label="Continuar aqui" @click="onReject" />
          </div>
        </div>
      </div>
    </template>
  </Toast>
</template>
